import React, { useState, useEffect } from 'react';

/**
 * Filter bar for the survey responses list (feature 052): user search, recommendation,
 * satisfaction range and date range, plus Apply / Clear / Export controls.
 * Uses the au- design system (au-filters/au-field) so it wraps and stacks responsively.
 */
const EMPTY = { search: '', survey: '', recommend: '', satisfaction_min: '', satisfaction_max: '', from: '', to: '' };

export default function SurveyFilters({ values, onApply, onClear, onExport }) {
  const [local, setLocal] = useState({ ...EMPTY, ...values });
  useEffect(() => { setLocal({ ...EMPTY, ...values }); }, [values]);

  const set = (k, v) => setLocal((p) => ({ ...p, [k]: v }));
  const submit = (e) => { if (e) e.preventDefault(); onApply(local); };

  return (
    <form className="au-filters sr-filters" onSubmit={submit}>
      {/* The fields wrap among themselves; the actions never leave their row. */}
      <div className="au-filters__fields">
        <div className="au-field sr-field-grow">
          <span className="au-field__label">Search</span>
          <input
            aria-label="Search user"
            className="au-input"
            placeholder="Name, email or user id"
            value={local.search}
            onChange={(e) => set('search', e.target.value)}
          />
        </div>

        {/* 105: this tab lists the original survey AND the 30-days survey (same questions). */}
        <div className="au-field">
          <span className="au-field__label">Survey</span>
          <select aria-label="Survey" className="au-select" value={local.survey} onChange={(e) => set('survey', e.target.value)}>
            <option value="">All</option>
            <option value="help_us_improve">3 Months</option>
            <option value="help_us_improve_30_days">30 Days</option>
          </select>
        </div>

        <div className="au-field">
          <span className="au-field__label">Recommendation</span>
          <select aria-label="Recommendation" className="au-select" value={local.recommend} onChange={(e) => set('recommend', e.target.value)}>
            <option value="">All</option>
            <option value="Yes">Recommends</option>
            <option value="No">Does not recommend</option>
          </select>
        </div>

        <div className="au-field">
          <span className="au-field__label">Satisfaction</span>
          <div className="sr-range-pair">
            <input aria-label="Min satisfaction" className="au-select sr-narrow" type="number" min="1" max="10" placeholder="Min" value={local.satisfaction_min} onChange={(e) => set('satisfaction_min', e.target.value)} />
            <span className="sr-range-dash">–</span>
            <input aria-label="Max satisfaction" className="au-select sr-narrow" type="number" min="1" max="10" placeholder="Max" value={local.satisfaction_max} onChange={(e) => set('satisfaction_max', e.target.value)} />
          </div>
        </div>

        <div className="au-field">
          <span className="au-field__label">From</span>
          <input aria-label="From date" className="au-select" type="date" value={local.from} onChange={(e) => set('from', e.target.value)} />
        </div>

        <div className="au-field">
          <span className="au-field__label">To</span>
          <input aria-label="To date" className="au-select" type="date" value={local.to} onChange={(e) => set('to', e.target.value)} />
        </div>

      </div>

      <div className="au-field au-field--actions sr-actions">
        <button type="submit" className="au-btn au-btn--primary">Apply</button>
        <button type="button" className="au-btn au-btn--ghost" onClick={() => { setLocal({ ...EMPTY }); onClear(); }}>Clear</button>
        <button type="button" className="au-btn au-btn--ghost" onClick={onExport}>⬇ Export CSV</button>
      </div>
    </form>
  );
}
